var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 mx-0",class:_vm.$vuetify.theme.dark ? 'background_light' : 'background_normal',attrs:{"fill-height":"","fluid":""}},[_c('sign-up',{staticClass:"mx-auto",class:_vm.$vuetify.breakpoint.mdAndUp ? 'my-15' : 'my-0'})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }